export default __webpack_public_path__ + "static/media/anpc-sal.71a64bb2.webp";